/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e=(E=>(E.DEFAULT="DEFAULT",E.FULLSCREEN="FULLSCREEN",E.MINIMIZED="MINIMIZED",E))(e||{});exports.windowStage=e;
